import React from 'react'

const Super = () => {
    return (
        <div>Super</div>
    )
}

export default Super